


















































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";

import Button from "@/shared/components/ui/Button.vue";
import Input from "@/shared/components/ui/Input.vue";
import {
  MicroEntryVerificationAccount,
  MicroEntryVerificationAccountStatus
} from "@/shared/types";
import { useBankAccountStore } from "@/employee/store/bankAccount";

@Component({
  components: {
    Button,
    Input,
  }
})

export default class MicroEntryVerificationAccountElement extends Vue {
  isEditing = false;

  bankAccountStore = useBankAccountStore();

  @Prop()
  account: MicroEntryVerificationAccount;
  @Prop()
  disabled: boolean;

  get isEditingButtonText () {
    return this.isEditing ? "Cancel" : "Edit";
  }

  get isVerifyButtonEnabled () {
    // Bend-16087 fix for not receiving the Reminder message from Finicity
    return !this.disabled && (this.isReadyForVerificationStatus || this.isPendingStatus);
  }

  get isReadyForVerificationStatus () {
    return this.account.verificationStatus === MicroEntryVerificationAccountStatus.ReadyForVerification;
  }

  get isPendingStatus () {
    return this.account.verificationStatus === MicroEntryVerificationAccountStatus.Pending;
  }

  get verifyButtonTooltipText () {
    if (this.isPendingStatus) {
      return "Account transactions may take up to 3 days to occur, please check back later to verify them.";
    } else if (this.isReadyForVerificationStatus) {
      return "Account transactions may take up to 3 days to be visible within your account, please have the transaction values available to verify.";
    }
    return "";
  }

  onVerifyClicked (): any {
    this.bankAccountStore.retrieveAchVerifyAccountUrl({ window, accountId: this.account.finicityAccountId });
  }

  onDeleteClicked () {
    this.bankAccountStore.deleteMicroEntryAccount(this.account);
  }

  toggleIsEditing () {
    this.isEditing = !this.isEditing;
    this.$emit("editButtonClicked", this.isEditing);
  }
}
